import React from "react";
import { Chip, makeStyles, Tooltip } from "@material-ui/core";
import { useTranslate } from "react-admin";

const useStyles = makeStyles(theme => ({
  chip: {
    color: props => props.themeColor[500],
    border: props => `1px solid ${props.themeColor[500]}`,
    backgroundColor: props => props.themeColor[50],
    marginLeft: theme.spacing(0.5),
    height: theme.spacing(2.5),
    fontSize: '0.7rem',
  },
  icon: {
    color: props => props.themeColor[500],
    marginLeft: '6px !important',
    height: theme.spacing(2),
    width: theme.spacing(2)
  },
}));

export default ({ themeColor, tooltipText, label, icon: Icon, ...props }) => {
  const translate = useTranslate();
  const classes = useStyles({ themeColor });

  return <Tooltip title={translate(tooltipText)}>
    <Chip
      className={classes.chip}
      size="small"
      label={translate(label)}
      icon={<Icon className={classes.icon} />}
      {...props}
    />
  </Tooltip>
}
